import {translateCurrency, formatPrice} from '@ajouvelimited/module-billybox/lib/product';
import { getFromId } from '../dataProvider/product';
import config from '../config';

export const SET_PRODUCTS = "PRODUCT_SET_PRODUCTS"
export const SET_PRODUCT = "PRODUCT_SET_PRODUCT"

export const load = (locale) => async dispatch => {

    try {
        const response = await fetch('https://geoip.sbfs.io/lookup');
        const result = await response.json();

        let country = 'fr';
        if(result.country) {
            if(result.country === 'GB') country = 'en'
            if(result.country === 'ES') country = 'es'
        }

        const products = [
            { id: config.product.normal[country], type: 'normal' },
            { id: config.product.selfEmployed[country], type: 'selfEmployed' },
            { id: config.product.company[country], type: 'company' },
        ]

        const remoteProducts = await Promise.all(products.map(product => getFromId(product.id)));

        products.forEach((product, index) => {
            const currency = remoteProducts[index].currency;
            product.amount = remoteProducts[index].amount;
            product.acquisitionAmount = remoteProducts[index].acquisitionAmount;
            product.currency = translateCurrency(currency, locale);
            product.acqPrice = formatPrice({ currency, amount: product.acquisitionAmount });
            product.subPrice = formatPrice({ currency, amount: product.amount });
            product.currencyCode = currency.toUpperCase();
        })

        return dispatch({ type: SET_PRODUCTS, products });

    } catch (error) {
        console.error(error)
    }
}